import React from 'react';
import {checkNullStr, isBoolTrue, subtractSize} from "../utils/ReactUtils";
import Tooltip from "@mui/material/Tooltip";

/**
 * A fully customizable label component.
 *
 * @example
 * <Label
 *      className={'m-0 p-0 px-1 text-nowrap'}
 *      textAt={'start'}
 *      variant={'primary'}
 *      color={'black'}
 *      asTag={false}
 *      bordered={false}
 *      iconClass={'fa fa-heart'}
 *      icon={'icon.png'}
 *      bgColor={'transparent'}
 *      style={{}}
 *      onClick={handleLabelClick}>
 *      You text
 * </Label>
 */
const Label = React.memo(({
                              className = "",
                              variant = "",
                              widthClass = "auto",

                              bgColor = "",
                              tooltip = "",
                              color = "",
                              overflow = "",
                              fontSize = "",
                              bordered = false,
                              textAt = "center",
                              alightAt,
                              width,
                              height,
                              iconStyle = {},

                              id,
                              key,
                              asTag = false,

                              required,
                              children,
                              iconClass = "",
                              icon,

                              style = {},
                              onClick,
                              ...rest
                          }) => {
    const TAG = "Label";

    return (<>
        <Tooltip title={tooltip}>
            <label
                className={`d-flexx w-${widthClass} text-${textAt} 
                al-${alightAt} jc-${textAt} m-1px-2py-1 rounded-2 ${className} bg-${variant} 
                    ${isBoolTrue(bordered) ? `border-2 border-solid border-${variant}` : ''}
                    `}
                id={id}
                key={key}
                style={{
                    width: width,
                    height: height,
                    fontSize: fontSize,
                    color: color,
                    backgroundColor: bgColor,
                    padding: isBoolTrue(asTag) ? '.1rem .8rem' : '',
                    ...style,
                    ...rest,
                }}
                onClick={onClick}
                onContextMenu={(e) => {
                    if (checkNullStr(tooltip)) {
                        e.preventDefault();
                    }
                }}
                {...rest}
            >
                {(checkNullStr(icon) || checkNullStr(iconClass)) &&
                    <span>
                       {checkNullStr(iconClass) ? <i className={`${iconClass}`}
                                                     style={{
                                                         color: color,
                                                         fontSize: checkNullStr(fontSize) ? subtractSize(fontSize, 2) : '',
                                                         ...iconStyle
                                                     }}/>
                           : <img src={icon}
                                  className={`object-fit-cover p-0 m-0`}
                                  style={{
                                      width: checkNullStr(fontSize) ? subtractSize(fontSize, 2) : '',
                                      height: checkNullStr(fontSize) ? subtractSize(fontSize, 2) : '',
                                      ...iconStyle
                                  }}
                           />
                       }
                    </span>
                }
                <span>{children}</span>
                {(isBoolTrue(required)) && <span className={'select-none text-danger'}>*</span>}
            </label>
        </Tooltip>
    </>)

    function fun() {

    }
});
export default Label;
